(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/widgets/ticker/assets/javascripts/utils.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : null;
const GameCache = svs.isServer ? trinidad.components.require('casino', 'game-cache') : null;
let constants;
let urlMapping;
if (svs.isServer) {
  constants = require('./constants.es6');
  urlMapping = trinidad.urlMapping;
} else {
  constants = svs.widget.ticker.constants;
  urlMapping = svs.core.urlMapping;
}
const {
  TickerBrand,
  TickerFeed
} = constants;
const getBrand = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerBrand.BINGO;
    case 'momangSlots':
    case 'momangLiveSlots':
      return TickerBrand.MOMANG;
    case 'casinoSlots':
    case 'casinoLiveSlots':
    default:
      return TickerBrand.CASINO;
  }
};
const getFeed = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerFeed.BINGO;
    case 'casinoLiveSlots':
    case 'momangLiveSlots':
      return TickerFeed.LIVE_CASINO;
    case 'casinoSlots':
    case 'momangSlots':
    default:
      return TickerFeed.SLOTS;
  }
};
const normalizeBingoWinners = (winners, gameRooms) => winners.map(winner => {
  const gameRoom = gameRooms.find(room => room.name === winner.game.name);
  return {
    gameName: winner.game.name,
    amountSek: winner.amountSek,
    href: gameRoom ? "".concat(urlMapping.get('bingoHome'), "/spela/").concat(gameRoom.id, "?gameName=").concat(gameRoom.name) : null,
    id: winner.timeStamp
  };
});
const localCasinoCache = {};
const normalizeCasinoWinners = winners => {
  var _GameCache$getGameCac, _svs$components$casin;
  const casinoGamesObj = svs.isServer ? (_GameCache$getGameCac = GameCache.getGameCache()) === null || _GameCache$getGameCac === void 0 ? void 0 : _GameCache$getGameCac.games : (_svs$components$casin = svs.components.casino) === null || _svs$components$casin === void 0 || (_svs$components$casin = _svs$components$casin.data) === null || _svs$components$casin === void 0 || (_svs$components$casin = _svs$components$casin.gameCache) === null || _svs$components$casin === void 0 ? void 0 : _svs$components$casin.index;
  const gamesList = Object.values(casinoGamesObj !== null && casinoGamesObj !== void 0 ? casinoGamesObj : {});
  return winners.map(winner => {
    const fallbackGame = {
      title: winner.game.name,
      name: null,
      opsGameId: winner.game.level3
    };
    let cachedGame = localCasinoCache[winner.game.level3];
    if (!cachedGame) {
      var _gamesList$find;
      const gameData = (_gamesList$find = gamesList.find(game => game.opsGameId === winner.game.level3)) !== null && _gamesList$find !== void 0 ? _gamesList$find : fallbackGame;
      const casinoTickerGame = {
        name: gameData.name,
        title: gameData.title,
        opsGameId: gameData.opsGameId
      };
      localCasinoCache[winner.game.level3] = casinoTickerGame;
      cachedGame = casinoTickerGame;
    }
    let href;

    if (cachedGame.name) {
      href = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(cachedGame.name);
    }
    return {
      gameName: cachedGame.title,
      amountSek: winner.amountSek,
      href,
      id: winner.timeStamp
    };
  });
};
const utils = {
  getBrand,
  getFeed,
  normalizeBingoWinners,
  normalizeCasinoWinners
};
if (svs.isServer) {
  module.exports = utils;
} else {
  svs.widget.ticker.utils = utils;
}

 })(window);